import { render, staticRenderFns } from "./menopauseuserinfo.vue?vue&type=template&id=60b48704&scoped=true&"
import script from "./menopauseuserinfo.vue?vue&type=script&lang=js&"
export * from "./menopauseuserinfo.vue?vue&type=script&lang=js&"
import style0 from "./menopauseuserinfo.vue?vue&type=style&index=0&id=60b48704&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60b48704",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\zy_frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('60b48704')) {
      api.createRecord('60b48704', component.options)
    } else {
      api.reload('60b48704', component.options)
    }
    module.hot.accept("./menopauseuserinfo.vue?vue&type=template&id=60b48704&scoped=true&", function () {
      api.rerender('60b48704', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/menopauseovary/components/menopauseuserinfo.vue"
export default component.exports